import * as Yup from "yup";

export const reasonSchema = Yup.object({
    reason_name: Yup.string().required(" Enter Reason"),
    status: Yup.string().required("Select Status"),
});


